import axios from "axios";
import store from "@/store";

const origin = window.location.origin;

const VUE_APP_BASE_URL =
  process.env.VUE_APP_BASE_URL && process.env.VUE_APP_BASE_URL !== "/"
    ? `${process.env.VUE_APP_BASE_URL}/api`
    : null;

axios.defaults.baseURL = VUE_APP_BASE_URL ? VUE_APP_BASE_URL : `${origin}/api`;

export const AXIOS_CLIENT = axios.create({
  baseURL: VUE_APP_BASE_URL ? VUE_APP_BASE_URL : `${origin}/api`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

function setToken() {
  const token =
    sessionStorage.getItem("access_token") ||
    localStorage.getItem("access_token") ||
    null;
  return token ? "Bearer " + token : null;
}

const QUERY_PARAMS = () => {
  let uri = window.location.href.split("?");
  if (uri.length == 2) {
    let vars = uri[1].split("&");
    let PARAMS = {};
    let tmp = "";
    vars.forEach(function (v) {
      tmp = v.split("=");
      if (tmp.length == 2) PARAMS[tmp[0]] = tmp[1];
    });
    return PARAMS;
  }
};

if (setToken()) {
  AXIOS_CLIENT.defaults.headers.common["Authorization"] = setToken();
} else if (QUERY_PARAMS()) {
  const ACCESS_TOKEN = QUERY_PARAMS().ACCESS_TOKEN;
  const ACCESS_EXPIRES_IN = +QUERY_PARAMS().ACCESS_EXPIRES_IN;

  const CALC_ACCESS_EXPIRES_IN =
    +Math.floor(new Date().getTime() / 1000) + ACCESS_EXPIRES_IN;

  sessionStorage.setItem("access_token", ACCESS_TOKEN);
  localStorage.setItem("access_token", ACCESS_TOKEN);
  sessionStorage.setItem("access_expires_in", CALC_ACCESS_EXPIRES_IN);
  localStorage.setItem("access_expires_in", CALC_ACCESS_EXPIRES_IN);

  AXIOS_CLIENT.defaults.headers.common["Authorization"] = setToken();
}

AXIOS_CLIENT.interceptors.response.use(undefined, (error) => {
  // Blob responseType error message
  if (
    error.request.responseType === "blob" &&
    error.response.data instanceof Blob &&
    error.response.data.type &&
    error.response.data.type.toLowerCase().indexOf("json") != -1
  ) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        error.response.data = JSON.parse(reader.result);
        resolve(Promise.reject(error));
      };
      reader.onerror = () => {
        reject(error);
      };
      reader.readAsText(error.response.data);
    });
  }

  // check token error
  if (error.response && error.response.status === 401) {
    store.state.currentUser.loginTimedOutAllowRefresh = true;
    delete AXIOS_CLIENT.defaults.headers.common["Authorization"];
    const isLogged =
      localStorage.getItem("login") || sessionStorage.getItem("login");
    if (isLogged) {
      store.dispatch("logOut");
    }
    // store.commit("mutate_login_timed_out", true);
  }
  return Promise.reject(error);
});

AXIOS_CLIENT.interceptors.request.use((config) => {
  const currData = +Math.floor(new Date().getTime() / 1000);
  const tokenExp =
    +sessionStorage.getItem("access_expires_in") ||
    +localStorage.getItem("access_expires_in");
  if (tokenExp && currData >= tokenExp) {
    store.state.currentUser.loginTimedOutAllowRefresh = true;
    delete AXIOS_CLIENT.defaults.headers.common["Authorization"];
    // store.commit("mutate_login_timed_out", true);
  }

  return config;
});

export const APIService = {
  async get(requestPath) {
    try {
      console.log("GET", this.getFullUrl(requestPath));
      const response = await AXIOS_CLIENT.get(this.getFullUrl(requestPath));
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async post(requestPath, data) {
    try {
      console.log("POST", this.getFullUrl(requestPath), data);
      const response = await AXIOS_CLIENT.post(
        this.getFullUrl(requestPath),
        data
      );
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async patch(requestPath, data) {
    try {
      console.log("PATCH", this.getFullUrl(requestPath), data);
      const response = await AXIOS_CLIENT.patch(
        this.getFullUrl(requestPath),
        data
      );
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async put(requestPath, data) {
    try {
      console.log("PUT", this.getFullUrl(requestPath), data);
      const response = await AXIOS_CLIENT.put(
        this.getFullUrl(requestPath),
        data
      );
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async delete(requestPath) {
    try {
      console.log("DELETE", this.getFullUrl(requestPath));
      const response = await AXIOS_CLIENT.delete(this.getFullUrl(requestPath));
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async downloadFile(requestPath) {
    try {
      const response = await AXIOS_CLIENT.get(this.getFullUrl(requestPath), {
        responseType: "blob",
      });
      return response;
    } catch (e) {
      console.log(e.response);
      throw e;
    }
  },
  async putFile(requestPath, data) {
    let form = new FormData();
    form.append("file", data);
    try {
      console.log("PUT FILE", this.getFullUrl(requestPath), form);
      const response = await AXIOS_CLIENT.put(
        this.getFullUrl(requestPath),
        form,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": `multipart/form-data; boundary="${form._boundary}"`,
          },
        }
      );
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async postFile(requestPath, data) {
    let form = new FormData();
    form.append("file", data);
    try {
      console.log("POST FILE", this.getFullUrl(requestPath), form);
      const response = await AXIOS_CLIENT.post(
        this.getFullUrl(requestPath),
        form,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": `multipart/form-data; boundary="${form._boundary}"`,
          },
        }
      );
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  getFullUrl(requestPath) {
    //return (requestPath.includes(this.baseUrl)) ? requestPath : this.baseUrl + requestPath
    return requestPath;
  },
  getRestFullEntityUrl(url, data) {
    return url + "/" + data.id;
  },
};
